import React, { useCallback } from "react";
import { useSdkContext } from "~/components/contexts";
import { useGA4CommonParameters, useSendImpressionEvents } from "~/components/rosetta/hooks";
import { SubscriptionButton } from "~/components/rosetta/subscription-button/styles";
export const RenewButton = ({
  className
}) => {
  const {
    handleTrackGA,
    handleTrackGA4,
    rosettaInstance
  } = useSdkContext();
  const {
    computeGA4CommonParameters
  } = useGA4CommonParameters();
  const {
    captureTrackImpressionEventTargetElement,
    intersection
  } = useSendImpressionEvents({
    ga4Event: useCallback(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...computeGA4CommonParameters(),
        call_to_action: "renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [computeGA4CommonParameters]),
    gaEvent: null
  });
  return /*#__PURE__*/React.createElement(SubscriptionButton, {
    className: className,
    ref: captureTrackImpressionEventTargetElement,
    onClick: () => {
      var _rosettaInstance$rule, _intersection$boundin;
      handleTrackGA({
        action: "Renewal/Masthead",
        category: "Renewal",
        label: window.location.href
      });
      handleTrackGA4({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "renew",
          trigger_point: "masthead renewal button"
        },
        subcategory: "entry_point"
      });
      const expiryReminder = rosettaInstance === null || rosettaInstance === void 0 || (_rosettaInstance$rule = rosettaInstance.rulesEngine.getOutcome("user")) === null || _rosettaInstance$rule === void 0 ? void 0 : _rosettaInstance$rule.expiryReminder;
      const {
        bottom,
        left,
        right,
        top
      } = (_intersection$boundin = intersection === null || intersection === void 0 ? void 0 : intersection.boundingClientRect) !== null && _intersection$boundin !== void 0 ? _intersection$boundin : {};
      window.postMessage({
        bottom,
        expiryReminder,
        left,
        right,
        top,
        type: "PIANO_RENEW_POPUP"
      }, "*");
    },
    "data-qa": "renew-button"
  }, "Renew & Save");
};
RenewButton.displayName = "RenewButton";